import { Button } from "@mui/material";
import SendIcon from "@mui/icons-material/Send";
import { TripState } from "types/user";
import useShareTrip from "hooks/trips/useShareTrip";

type Props = {
  trip: TripState;
  genericVin: string;
  shareRoute?: string;
  includeExperience?: boolean;
};

const ShareTripButton = ({
  trip,
  genericVin,
  shareRoute,
  includeExperience,
}: Props) => {
  const { handleShareTrip } = useShareTrip({
    trip,
    genericVin,
    shareRoute,
    includeExperience,
  });

  const disabled = !trip.fromAddress && !trip.toAddress
  return (
    <Button disabled={disabled} startIcon={<SendIcon />} onClick={handleShareTrip}>
      Share
    </Button>
  );
};

export default ShareTripButton;
